import { render, staticRenderFns } from "./BookingSearch.vue?vue&type=template&id=24b8fe9a&scoped=true&"
import script from "./BookingSearch.vue?vue&type=script&lang=js&"
export * from "./BookingSearch.vue?vue&type=script&lang=js&"
import style0 from "./BookingSearch.vue?vue&type=style&index=0&id=24b8fe9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8fe9a",
  null
  
)

export default component.exports